import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Fetchable from '~/commons/components/util/Fetchable';
import Html from '~/commons/components/util/Html';
import Page from '../layout/Page';

const Btn = ({ mascot, active, ...props }) => (
  <button
    type="button"
    className="btn"
    style={{ width: '120px', maxWidth: '22vw' }}
    {...props}
  >
    <div className="ratio ratio-1x1">
      {active && (
        <div
          className="img-bg-contain"
          style={{
            backgroundImage: 'url(/assets/img/btn-rounded-border.png)',
            transform: 'scale(1.13)',
          }}
        />
      )}
      <div
        className="img-bg-contain"
        style={{ backgroundImage: 'url(/assets/img/btn-rounded.png)' }}
      />
      <div style={{ padding: '10%' }}>
        <div className="ratio ratio-1x1">
          <div
            className="img-bg-contain"
            style={{ backgroundImage: `url("/uploads/${mascot.image[0].path}")` }}
          />
        </div>
      </div>
    </div>
  </button>
);

const Content = ({
  mascots,
  title, children,
  initValue,
  onChange = () => {},
}) => {
  const { i18n } = useTranslation();
  const [state, setState] = useState(initValue ?? mascots[0]._id);
  const selected = state;
  const setSelected = (m) => {
    setState(m);
    onChange(m);
  };

  const m = mascots.find((mascot) => mascot._id === selected);

  useEffect(() => {
    if (!initValue && !!mascots[0]) {
      onChange(mascots[0]._id);
    }
  }, [!!initValue, !!mascots[0]]);

  return (
    <div className="container">
      {title && <h1 className="h2 pb-4 fw-bold">{title}</h1>}
      <div className="row justify-content-between align-items-center">
        <div className="col-12 col-md-auto order-1 order-md-0 text-center">
          {mascots.map((mascot) => (
            <Fragment key={mascot._id}>
              <Btn
                mascot={mascot}
                active={selected === mascot._id}
                onClick={() => setSelected(mascot._id)}
              />
              <br className="d-none d-md-block" />
            </Fragment>
          ))}
        </div>
        <div className={`
          col-10 col-sm-8 col-md-5 col-lg-4 order-0 order-md-1
          mx-auto mx-md-0
        `}
        >
          {m && (
            <div className="ratio" style={{ '--bs-aspect-ratio': '120%' }}>
              <div
                className="img-bg-contain"
                style={{ backgroundImage: `url("/uploads/${m.animation[0].path}")` }}
              />
            </div>
          )}
        </div>
        <div className="col-md-4 order-2 order-md-2 py-5 py-m-0">
          {m && (
            <>
              <h2>{i18n.pickLng(m.name)}</h2>
              <Html>{i18n.pickLng(m.description)}</Html>
              {children}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const PageMascots = (props) => (
  <Page>
    <Fetchable req={{ url: '/api/mascots' }}>
      {({ rows: mascots }) => <Content mascots={mascots} {...props} />}
    </Fetchable>
  </Page>
);

export default PageMascots;
